// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PaymentTransactionResponse } from './payment-transaction-response';

/** See com.rev360.pms.api.controller.accounting.payment.AccountingInvoicePaymentResponse */
/* istanbul ignore next */
@GandalfModel
export class AccountingInvoicePaymentResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	amount!: number | null;

	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	paymentDate!: Date | null;

	@GandalfProperty({ designType: Number })
	paymentGroupId!: number | null;

	@GandalfConstantDecorator(constants.PaymentMethodType)
	@GandalfProperty({ designType: constants.PaymentMethodType })
	paymentMethod!: constants.PaymentMethodType | null;

	@GandalfConstantDecorator(constants.PaymentMethodCreditCardType)
	@GandalfProperty({ designType: constants.PaymentMethodCreditCardType })
	paymentMethodCardType!: constants.PaymentMethodCreditCardType | null;

	@GandalfProperty({ designType: String })
	paymentPayerName!: string | null;

	@GandalfConstantDecorator(constants.PaymentStatus)
	@GandalfProperty({ designType: constants.PaymentStatus })
	paymentStatus!: constants.PaymentStatus | null;

	@GandalfProperty({ designType: PaymentTransactionResponse })
	paymentTransaction!: PaymentTransactionResponse | null;

	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

	@GandalfProperty({ designType: String })
	referenceNumber!: string | null;

}
